import { liveChatActorName } from "@productlane/lib/src/live-chat-system-message"

export type LiveChatSystemMessage =
	| { kind: "joined"; name: string }
	| { kind: "ended"; name: string }
	| { kind: "notice"; text: string }

const JOINED_PATTERN = /^(.+?) joined(?: the conversation)?\.?$/
const ENDED_PATTERN = /^(.+?) (?:ended|left)(?: the conversation)?\.?$/

// The delivery confirmation ends on a colon ("...the Agent may help:") because
// the widget prints the AI answer underneath it.
const stripTrailingColon = (text: string) => text.replace(/\s*:\s*$/, "")

// The widget sends its confirmations as HTML, so a raw <br/> would show up here.
const stripHtml = (text: string) =>
	text
		.replace(/<br\s*\/?>/gi, " ")
		.replace(/<[^>]*>/g, "")
		.replace(/\s+/g, " ")

export function parseLiveChatSystemMessage(
	content: string,
): LiveChatSystemMessage {
	const trimmed = stripHtml(content).trim()

	const joined = JOINED_PATTERN.exec(trimmed)?.[1]
	if (joined) return { kind: "joined", name: liveChatActorName(joined) }

	const ended = ENDED_PATTERN.exec(trimmed)?.[1]
	if (ended) return { kind: "ended", name: liveChatActorName(ended) }

	return { kind: "notice", text: stripTrailingColon(trimmed) }
}
